import type { FireIconProps } from './types';

export default function FireHydrant({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Cap / bonnet */}
      <rect x="9" y="2" width="6" height="3" rx="1" />
      {/* Stem */}
      <line x1="12" y1="5" x2="12" y2="8" />
      {/* Body */}
      <rect x="8" y="8" width="8" height="10" rx="2" />
      {/* Left outlet */}
      <line x1="8" y1="12" x2="5" y2="12" />
      <circle cx="4" cy="12" r="1" />
      {/* Right outlet */}
      <line x1="16" y1="12" x2="19" y2="12" />
      <circle cx="20" cy="12" r="1" />
      {/* Base */}
      <line x1="7" y1="18" x2="17" y2="18" />
      {/* Feet */}
      <line x1="9" y1="18" x2="8" y2="21" />
      <line x1="15" y1="18" x2="16" y2="21" />
      <line x1="6" y1="21" x2="18" y2="21" />
    </svg>
  );
}
